import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "../../../../form/src/common/components/form-staff-selector/pc/index.vue";
import mobile from "../../../../form/src/common/components/form-staff-selector/mobile/index.vue";
export const info = {
    title: "混合选人",
    title_i18n: "{\"zh\": \"混合选人\", \"en\": \"StaffDeptMixed\"}",
    type: "StaffDeptMixed",
    icon: "h-icon-all-a-Mixedselection-o",
    dataItemType: DataItemType.StaffDeptMix,
    formControllerType: FormControlType.StaffDeptMixed,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
